import { UseMutationResult } from '@tanstack/react-query';
import { UpdateDepartmentResponse, UpdateRegisterResponse } from 'compliance-api/generated.ts';
import { Form, FormikErrors, FormikProvider, FormikValues, useFormik } from 'formik';
import * as yup from 'yup';
import { BaseModalProps, Button, ModalContentWrapper, TextInputField } from 'ui';

type initialValuesType = {
  name: string;
  id: number;
};
const initialValues: initialValuesType = {
  name: '',
  id: 0,
};

type mutationResponse = UpdateDepartmentResponse | UpdateRegisterResponse;

export interface AddFormModalProps extends BaseModalProps {
  name: string;
  id: number;
  title: string;
  mutation: ({
    setErrors,
  }: {
    setErrors: (errors: FormikErrors<FormikValues>) => void;
  }) => UseMutationResult<
    mutationResponse,
    unknown,
    Record<string, any> & { id: number; name: string },
    unknown
  >;
}

const validationSchema = yup.object({
  name: yup.string().required('Name is required').typeError('Name is required'),
});

export const RenameModal = ({ id, open, name, title, mutation, onClose }: AddFormModalProps) => {
  const handleCloseModal = () => {
    formik.resetForm();
    onClose();
  };

  const handleFormSubmit = async (values: { name: string; id: number }) => {
    await mutateAsync(values);
  };

  const formik = useFormik({
    initialValues: {
      ...initialValues,
      id: id,
      name: name,
    },
    validateOnChange: false,
    validateOnMount: false,
    validateOnBlur: false,
    validationSchema,
    enableReinitialize: true,
    onSubmit: async values => {
      await handleFormSubmit(values);
      handleCloseModal();
    },
  });

  const { mutateAsync, isLoading } = mutation({ setErrors: formik.setErrors });

  return (
    <ModalContentWrapper open={open} title={`Rename ${title}`} onClose={onClose}>
      <FormikProvider value={formik}>
        <Form className="flex flex-col space-y-6">
          <div className="space-y-4">
            <TextInputField name="name" />
          </div>
          <div>
            <Button loading={isLoading} type="button" onClick={formik.submitForm}>
              Rename {title}
            </Button>
          </div>
        </Form>
      </FormikProvider>
    </ModalContentWrapper>
  );
};
